import logger from "../../../utils/logger";
import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Label,
  Row,
  Button,
  Form,
  Input,
  Spinner,
  CardBody,
} from "reactstrap";

// redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { createCustomer } from "../../../slices/apps/authSlice";

// router
import { Link, useLocation, useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// görsel importlar
import Logo from "../../../assets/images/logo/metiner_avantaj_logo.png";

const Register = () => {
  document.title = "Kayıt Ol | Metiner Avantaj+";

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const { phoneNumber, companyId } = location.state || {};

  const { createCustomerLoading } = useSelector(
    (state) => ({
      createCustomerLoading: state.auth.createCustomerLoading,
    }),
    shallowEqual
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      phoneNumber: phoneNumber || "",
      plateNumber: "",
      email: "",
      companyId: companyId || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .max(50, "Ad en fazla 50 karakter olabilir.")
        .required("Lütfen adınızı giriniz."),
      lastName: Yup.string()
        .max(50, "Soyad en fazla 50 karakter olabilir.")
        .required("Lütfen soyadınızı giriniz."),
      plateNumber: Yup.string()
        .max(20, "Plaka en fazla 20 karakter olabilir.")
        .required("Lütfen plaka numarasını giriniz."),
      email: Yup.string()
        .email("Lütfen geçerli bir e-posta adresi giriniz.")
        .max(100, "E-posta en fazla 100 karakter olabilir.")
        .notRequired(),
    }),
    onSubmit: async (values) => {
      try {
        await dispatch(createCustomer(values)).unwrap();
        navigate("/customer/welcome", { state: { userStatus: "new_user" } });
      } catch (error) {
        logger.error("Müşteri oluşturma hatası:", error);
      }
    },
  });

  useEffect(() => {
    if (!phoneNumber || !companyId) {
      navigate("/404");
    } else {
      setIsLoading(false);
    }
  }, [phoneNumber, companyId, navigate]);

  const handleCarPlateChange = (e) => {
    const value = e.target.value.replace(/\s/g, "").toUpperCase();
    validation.setFieldValue("plateNumber", value);
  };

  if (isLoading) {
    return (
      <div id="preloader">
        <div id="status">
          <img
            src={Logo}
            className="mb-2"
            alt="Metiner Avantaj+"
            style={{ objectFit: "contain", width: "10rem" }}
          />
          <div className="spinner-border text-primary avatar-xs" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="text-center pt-5">
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={Logo} alt="Metiner Avantaj+" height="100" />
                    </Link>
                  </div>
                  <CardBody className="p-lg-5 p-4">
                    <Form onSubmit={validation.handleSubmit} autoComplete="off">
                      <Row className="gy-3">
                        <Col lg={12}>
                          <Label>Ad</Label>
                          <Input
                            type="text"
                            name="firstName"
                            placeholder="Can"
                            maxLength={50}
                            value={validation.values.firstName}
                            onChange={validation.handleChange}
                            invalid={
                              !!(
                                validation.touched.firstName &&
                                validation.errors.firstName
                              )
                            }
                          />
                          {validation.touched.firstName &&
                            validation.errors.firstName && (
                              <div className="invalid-feedback d-block">
                                {validation.errors.firstName}
                              </div>
                            )}
                        </Col>

                        <Col lg={12}>
                          <Label>Soyad</Label>
                          <Input
                            type="text"
                            name="lastName"
                            placeholder="Yılmaz"
                            maxLength={50}
                            value={validation.values.lastName}
                            onChange={validation.handleChange}
                            invalid={
                              !!(
                                validation.touched.lastName &&
                                validation.errors.lastName
                              )
                            }
                          />
                          {validation.touched.lastName &&
                            validation.errors.lastName && (
                              <div className="invalid-feedback d-block">
                                {validation.errors.lastName}
                              </div>
                            )}
                        </Col>

                        <Col lg={12}>
                          <Label>E-posta Adresi</Label>
                          <Input
                            type="email"
                            name="email"
                            placeholder="musteri@ornek.com"
                            maxLength={100}
                            value={validation.values.email}
                            onChange={validation.handleChange}
                            invalid={
                              !!(
                                validation.touched.email &&
                                validation.errors.email
                              )
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <div className="invalid-feedback d-block">
                                {validation.errors.email}
                              </div>
                            )}
                        </Col>

                        <Col lg={12}>
                          <Label>Plaka</Label>
                          <Input
                            type="text"
                            name="plateNumber"
                            placeholder="38ABC000"
                            maxLength={20}
                            value={validation.values.plateNumber}
                            onChange={handleCarPlateChange}
                            invalid={
                              !!(
                                validation.touched.plateNumber &&
                                validation.errors.plateNumber
                              )
                            }
                          />
                          {validation.touched.plateNumber &&
                            validation.errors.plateNumber && (
                              <div className="invalid-feedback d-block">
                                {validation.errors.plateNumber}
                              </div>
                            )}
                        </Col>

                        <Col lg={12} className="mt-4">
                          <Button
                            type="submit"
                            color="primary"
                            className="w-100"
                            disabled={createCustomerLoading}
                          >
                            {createCustomerLoading ? (
                              <>
                                <Spinner size="sm" className="me-2" />
                                Kaydediliyor...
                              </>
                            ) : (
                              "Kayıt Ol"
                            )}
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer h-auto pb-2">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted">
                  <p className="mb-2" style={{ letterSpacing: "0.8px" }}>
                    Metiner Avantaj+ &copy; {new Date().getFullYear()} | 0 352 3
                    555 444 | metiner@boschservice.com.tr
                    <br />
                    <i className="mdi mdi-heart text-danger"></i> by{" "}
                    <a
                      href="https://kodexis.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Kodexis
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default Register;
